<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    console.log(localStorage.getItem('path'))
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      console.log('移动端')
    //说明是移动端
      let path = localStorage.getItem('path')
      if(path.indexOf('mt') == -1){
        if(path.split("/")[1] == ''){
          path = './mt_tab'
        }else{
          path = './mt_' + path.split("/")[1]
        }
      }
      this.$router.push(path)
      // this.$router.push('/mt_tab')
    } else {
      console.log('PC端')
        //说明是pc端
        let path = localStorage.getItem('path')
        if(path.indexOf('mt') != -1){
          if(path.split("_")[1] == 'tab'){
            path = './'
          }else{
            path = './' + path.split("_")[1]
          }
          
        }
        this.$router.push(path)
        // this.$router.push('/')
    }
  },
  destroyed(){
    
  }
}
</script>

<style>
html body{
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue